import React from "react";
import { useTranslation } from "react-i18next";

const Dead = React.memo(() => {
  const { t } = useTranslation();
  return (
    <>
      {t("t:DeadTitle", "__DeadTitle")}
      <br />
      {t("t:DeadDescription", "__DeadDescription")}
    </>
  );
});
export default Dead;
